import Vue from 'vue'
//给vue原型添加将元素移动至body方法
Vue.prototype.$removeToBody = function() {
  let body = document.querySelector("body");
  if (body.append) {
    body.append(this.$el);
  } else {
    body.appendChild(this.$el);
  }
};
import App from './App'
import router from './router/router'
import ElementUI from 'element-ui';
Vue.use(ElementUI, {zIndex: 19960501});
import 'element-ui/lib/theme-chalk/index.css';
import imDetail from "./js/im-detail";
import im from "./js/im";
Vue.prototype.$im = im;
import $ from "jquery"
import bus from "./js/bus/bus";
import debounce from "./js/utils/debounce";

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

router.afterEach((to, from) => {
  //如果是从Main组件之后跳转回登录，刷新页面清除im dom元素
  if ((to.name === "login" || to.name === "register" || to.name === "smsLogin")
    && from.matched.length > 0 && from.matched[0].name === 'main')
    location.reload();
});

router.beforeEach((to, from, next) => {
  if (to.name === "main" || to.name === "spaces") {
    im.getAccountInfo(({id}) => {
      next("/spaces/" + id + "/home")
    });
  } else {
    next();
  }
});

$(document).scroll(debounce(function () {
  let h= $(document).height();  //网页文档的高度
  let c = $(document).scrollTop();  //滚动条距离网页顶部的高度
  let wh = $(window).height(); //页面可视化区域高度
  if (wh + c >= (h - 50)){
    bus.$emit("scrollToEnd");
  }
}, 1000));

/* eslint-disable no-new */
let vue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});
imDetail.install(vue);




// WEBPACK FOOTER //
// ./src/main.js